// パスワードの表示
export default class {
  constructor() {
    const pwd = [];
    pwd.push(document.getElementById('formItem-pw')); // パスワード
    if (document.getElementById('formItem-pwConfirm') != null) {
      pwd.push(document.getElementById('formItem-pwConfirm')); // 確認用のパスワード
    }
    const pwdCheck = document.getElementById('formItem-showPw');
    if(pwdCheck != null) {
      pwdCheck.addEventListener('change', function () {
        if (pwdCheck.checked) {
          for (let i = 0; i < pwd.length; i++) {
            pwd[i].setAttribute('type', 'text');
          }
        } else {
          for (let i = 0; i < pwd.length; i++) {
            pwd[i].setAttribute('type', 'password');
          }
        }
      }, false);
    }
  }
}
